module.exports = __webpack_public_path__ + "static/media/globe-stand.4ae41d01.svg";